//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    apiUrl,
    apiParams,
    homeMenu
} from "@/const/const";

export default {
    data() {
        return {
            msg: 'Hello World!',
            isShowLoading: false,
            groupData: [],
            companyId: '',
            isToast: false,
            canFetch: true,
        }
    },
    created() {
        document.title = '货物跟踪';
        // 如果参数为undefined，axios不会传该参数到服务器！
        // 现在后台将companyId/openId等存到session，但验证权限接口menuPermission还是需要前端传递companyId参数的，因此保留这里的代码
        apiParams.companyId = this.getUrlParams('companyId') || apiParams.companyId || '';
        apiParams.code = this.getUrlParams('code') || apiParams.code || '';
        this.getMenu()
    },
    methods: {
        getMenu() {
            let data = {
                companyId: apiParams.companyId,
                code: apiParams.code,
                openId: apiParams.openId,
            };
            this.isShowLoading = true;
            this.$http.post(apiUrl.getAvailableMenu, data).then(response => {
                this.isShowLoading = false;
                if (response.data.code !== 200) {
                    this.showToast(response.data.info);
                    return;
                }
                let availableMenu = response.data.data || [];
                if (availableMenu.length === 0) {
                    this.groupData = [homeMenu.kehu, homeMenu.yewu, homeMenu.siji];
                    return;
                }
                debugger;
                availableMenu.forEach(item => {
                    let menuItem = {};
                    if (item.menuType === '0') {
                        menuItem = homeMenu.kehu
                    } else if (item.menuType === '1') {
                        menuItem = homeMenu.yewu
                    } else if (item.menuType === '2') {
                        menuItem = homeMenu.siji
                    }
                    if (item.menuTitle) {
                        let menuTitle = item.menuTitle.split(',');
                        for (let j = 0; j < menuItem.contentData.length; j++) {
                            let label = menuItem.contentData[j].label;
                            if (!menuTitle.includes(label)) {
                                menuItem.contentData.splice(j, 1);
                                j--
                            }
                        }
                    }

                    this.groupData.push(menuItem)
                });
            }).catch(error => {
                console.error(error);
                this.isShowLoading = false
            })
        },

        goMenu(menuType, path) {

            if (!this.canFetch) return;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.canFetch = false;
            let data = {
                companyId: apiParams.companyId,
                menuType: menuType,
                code: apiParams.code,
                openId: apiParams.openId, // 第二次调用开始会使用，代替code
            };
            this.$http.post(apiUrl.menuPermission, data)
                .then((response) => {
                    this.$vux.loading.hide();
                    // 判断响应状态
                    let resultData = response.data;
                    let code = resultData.code;
                    let info = resultData.info; // 412或500的提示语
                    if (code === 412) {
                        this.showToast(info, 2000, 'warn')

                    } else if (code === 500) {
                        this.showToast(info, 2000, 'warn')

                    } else {
                        // 判断是否有权限
                        let hasPermission = resultData.data.hasPermission || '';
                        let openId = resultData.data.openId || '';
                        let unPermissionInfo = resultData.data.unPermissionInfo;
                        apiParams.openId = apiParams.openId || openId;
                        if (hasPermission) {
                            this.$router.push({
                                path: path,
                                // query: {
                                //   openId: openId
                                // }
                            })
                        } else {
                            this.showToast(unPermissionInfo, 2000, 'warn')

                        }
                    }
                    this.canFetch = true // 要恢复可以获取状态，可继续提示暂无更多数据
                })
                .catch((error) => {
                    this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                    this.$vux.loading.hide();
                    console.error(error.config);
                    console.error('Error', error.message);
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.vue